import { tv } from "tailwind-variants";

/**
 * pillRowVariants is the shared rounded "pill" row used by both the chat thread
 * list and the module list, so the two stay visually in sync. Hover fills the
 * pill; active paints it in the brand color. The base sets `group` so children
 * can reveal themselves on row hover.
 */
export const pillRowVariants = tv({
  base: "interactive-group group text-foreground-hovered 4xl:text-base hover:bg-background-neutral-hovered relative isolate flex h-10 w-full cursor-pointer items-center gap-2 rounded-full py-1 pr-1 pl-3 text-sm",
  variants: {
    active: {
      true: "bg-brand text-brand-on-brand hover:bg-brand",
      false: "",
    },
  },
  defaultVariants: {
    active: false,
  },
});

/**
 * pillActionVariants is the round, transparent action control inside a pill row
 * (the chat list's menu trigger, the module list's pin and settings icons).
 */
export const pillActionVariants = tv({
  base: "relative inline-flex size-8 shrink-0 items-center justify-center rounded-full bg-transparent transition-[background-color,opacity] duration-150 hover:bg-gray-200 data-[state=open]:bg-gray-200 dark:hover:bg-white/10 dark:data-[state=open]:bg-white/10",
});
